import { object } from 'prop-types';
import { Fragment } from 'react';

import * as Utils from 'atg/utils/Utils';
import { getText } from 'shared/utils/Text';

const TemplateItemInfo = ({ template }) => (
  <Fragment>
    <h2 className="title template-name">{template.getDisplayName()}</h2>
    <div className="template-modified">
      {getText(
        'dialog-archive-templates-modified',
        Utils.formatDateTime(template.getModifiedTime()),
      )}
    </div>
  </Fragment>
);

TemplateItemInfo.propTypes = {
  template: object.isRequired, // SavedTemplate
};

export default TemplateItemInfo;
